export default {
  getPausas: state => state.pausas,
  getRamaisState: state => state.ramais,
  getFilas: state => state.filas,
  getStatusOperadores: state => state.statusOperadores,
  getPermission: state => state.permission,
  getOperadores: state => state.operadores,
}
